

const objectIsEmpty = (obj:Object) => {
   return !Object.values(obj).some(value => value);    
}

export {objectIsEmpty};
